(ns ui.components.zapkit-variants
  "Read one slot of a generated `zapkit_styles.cljs` map. A slot has `:base`, one
   key for each variant dimension, `:compound-variants` and `:default-variants`.
   `slot-class` gives the classes of a slot for some variant values, in the order
   of `cva` in ZapKit: the base, each variant, then each compound variant that
   matches. `uu/cm` resolves the conflicts as the `cn` function of ZapKit does."
  (:require
   [ui.util :as uu]))

(def ^:private slot-keys
  #{:base :compound-variants :default-variants})

(defn- text
  "A variant value as text. A keyword, a string and a boolean of the same word
   are equal, as in the JSON of ZapKit."
  [value]
  (cond
    (keyword? value) (name value)
    (nil? value) nil
    :else (str value)))

(defn- compound-classes
  "ZapKit spells the classes of a compound variant `class` in some files and
   `className` in others."
  [compound]
  (or (:class compound)
      (:class-name compound)))

(defn compound-class
  "Return the classes of the compound variants of a slot that match the variant
   values `variants`, or nil. A compound variant matches when all its conditions
   have the value in `variants`. A variant value that `variants` has not given
   comes from `:default-variants`."
  [slot-styles variants]
  (let [values (merge (:default-variants slot-styles) variants)
        classes (keep (fn [compound]
                        (let [conditions (dissoc compound :class :class-name)]
                          (when (every? (fn [[dimension expected]]
                                          (= (text expected)
                                             (text (get values dimension))))
                                        conditions)
                            (compound-classes compound))))
                      (:compound-variants slot-styles))]
    (when (seq classes)
      (apply uu/cm classes))))

(defn slot-class
  "Return the classes of a slot for the variant values `variants`. A value that
   `variants` has not given comes from `:default-variants`. A dimension that the
   slot does not have is ignored."
  [slot-styles variants]
  (let [values (merge (:default-variants slot-styles) variants)
        dimensions (remove slot-keys (keys slot-styles))]
    (uu/cm (:base slot-styles)
           (->> dimensions
                (keep (fn [dimension]
                        (when (contains? values dimension)
                          (get-in slot-styles [dimension (keyword (text (get values dimension)))]))))
                (apply uu/cm))
           (compound-class slot-styles variants))))
